import TimeSliderController from "../../app/TimeSliderController";
import store from "../../app/store";
import RadarAnimation from "./RadarAnimation";
import tileRadarLayer from "./TileRadarLayer";
import RadarStaticAnimation from "./RadarStaticAnimation";
import trans from "../../app/trans";
import ObsTimeSliderController from "../../app/ObsTimeSliderController";

class RadarTimeSliderController extends ObsTimeSliderController{


    constructor(view, staticAnimation, preloadedAnimation) {
        super(view, staticAnimation);

        this.view.setLoopSteps(10);
        this.view.setFutureSteps(false);

        if (preloadedAnimation)
            this.movieAnimation=preloadedAnimation;
        else
            this.movieAnimation=new RadarAnimation(tileRadarLayer);

        this.view.bindHandleStartMovieAnimation(this.startMovieAnimation.bind(this));
        this.view.bindHandleStopMovieAnimation(this.stopMovieAnimation.bind(this));
        this.view.bindHandleSelectFutureOverlay(this.selectFutureOverlay.bind(this));
        this.view.bindHandleGetFutureTranslation(this.getFutureTranslation.bind(this));
        // this.view.bindHandleClickPremium(this.clickPremium.bind(this));

        store.on("radarCalendar", this.update.bind(this));

        // this.registerTimestampEvent();

        this.movieAnimation.on("timeAnimationPrintTs", function(timestamp){
            const calendar = store.get("radarCalendar");
            let text = calendar.ts2hour(new Date(timestamp));
            if ( timestamp > calendar.obsend )
                text = trans["FORECAST"] + " - " + text;
            this.view.setProgressText(text, timestamp > calendar.obsend);
        }.bind(this));

        this.movieAnimation.on("timeAnimationStart", function(){
            this.view.enablePreloadedPlayBar();
            this.view.blockMovie();
        }.bind(this));

        this.movieAnimation.on("timeAnimationStop", function(){
            this.view.disablePreloadedPlayBar();
            this.view.unBlockMovie();
        }.bind(this));

        this.movieAnimation.on("timeAnimationPercent", function(progress){
            this.view.setProgressPercent(progress);
        }.bind(this));

        store.on("radarRange", function (value){
            this.movieAnimation.setTimeRange(value);
        }.bind(this));
    }



    startMovieAnimation(){
        this.pushEventPlayMovie();
        this.animation.stopAnimation();
        this.movieAnimation.startAnimation();
    }

    pushEventPlayMovie() {
        // dataLayer.push({
        //     'ga4_action_name': 'visor_playmovie',
        //     'ga4_tag_name': 'click'
        // })
    }


    stopMovieAnimation(){
        this.movieAnimation.stopAnimation();
    }

    startAnimation(loopSteps, futuresteps){
        this.movieAnimation.stopAnimation();
        super.startAnimation(loopSteps, futuresteps);
    }

    selectFutureOverlay(){
        store.set("overlay","precip");
    }

    getFutureTranslation(){
        return trans.FUTURE.toUpperCase()
    }

    createAnimation(){
        return new RadarStaticAnimation();
    }

    registerTimestampEvent(){
        store.on("radarTimestamp", this.updateTimestampView.bind(this));
    }

    updateTimestampView(ts){
        const nslot = this.calendar.indxBestTs(ts);
        this.view.changeSlot(nslot);
        this.view.setDayText(this.calendar.ts2day(this.calendar.timestamps[nslot]));
        this.view.setHourText(this.calendar.ts2hour(this.calendar.timestamps[nslot]));
    }

    getTimestamp(){
        return store.get("radarTimestamp");
    }

    setTimestamp(timestamp){
        store.set("radarTimestamp", timestamp);
    }

}

export default RadarTimeSliderController;
